import { component, html, virtual } from '@pionjs/pion';
import { until } from 'lit-html/directives/until.js';

import styles from './styles/index.css';
import css from './main.module.css';

const init$ = () =>
	Promise.all([
		import('./root.js'),
		import('./config').then(({ config$ }) => config$()),
	]).then(
		([{ Root }, config]) =>
			html`<config-provider .value=${config}>
				${virtual(Root)({ config })}
			</config-provider>`,
		(e) =>
			html`<div class="failure">
				<b>Failed to initializing application:</b>
				<pre>${e.message}</pre>
			</div>`,
	);

const Mp = () => until(init$(), html`<cz-spinner />`);

customElements.define('shelves-main', component(Mp, { styleSheets: [css] }));

document.body.appendChild(document.createElement('shelves-main'));

document.adoptedStyleSheets = [styles];
